import type { ReactNode } from 'react';

type Props = {
	children: ReactNode;
	className?: string;
};

export default function Section({ children, className }: Props) {
	return (
		<section className={`container mx-auto py-4 px-6 max-md:py-2 max-md:px-4 ${className}`}>
			{children}
		</section>
	);
}
